/** Why an application was declined, as reportable categories (the reason in words is kept alongside). */
export const DECLINE_REASON_LABELS: Record<string, string> = {
  AFFORDABILITY: 'Affordability',
  ADVERSE_CREDIT_HISTORY: 'Adverse credit history',
  INCOMPLETE_DOCUMENTS: 'Incomplete or unverifiable documents',
  INSUFFICIENT_SECURITY: 'Insufficient security',
  OUTSIDE_POLICY: 'Outside lending policy',
  FRAUD_OR_KYC_CONCERN: 'Fraud / KYC concern',
  OTHER: 'Other',
};

/** Where in the process the application was declined. */
export const DECLINE_STAGE_LABELS: Record<string, string> = {
  VERIFICATION: 'verification',
  EVALUATION: 'credit assessment',
  COMMITTEE: 'Credit Committee',
};

export const declineReasonLabel = (category?: string | null): string =>
  (category && DECLINE_REASON_LABELS[category]) || category || '';
